import { operateMaxShowLength } from '@/store/dict/config'

// 客户类型 options
const customerTypeOptions = [
  { label: '全部', value: '' },
  { label: '个人', value: 1 },
  { label: '企业', value: 2 },
]

// 订单状态 options
const orderStateOptions = [
  { label: '全部', value: '' },
  { label: '进行中', value: 0 },
  { label: '已完成', value: 1 },
  /**
   * 全部、履约中，退车核算，已关闭
   * * */
]

// 汇总标题映射
const summaryMap = {
  totalAmount: '应收总租金',
  receivedAmount: '实收总租金',
  surplusAmount: '欠租总金额',
}

// 还款状态
const repaymentStateOption = [
  { label: '全部', value: '' },
  { label: '未结清', value: 0 },
  { label: '已结清', value: 1 },

]

// 租赁状态
const leaseStatusOption = [
  { label: '发车待验车', value: 1500 },
  { label: '履约中', value: 2500 },
  { label: '退车待验车', value: 3500 },
  { label: '订单待核算', value: 4500 },
  { label: '费用待结算', value: 5000 },
  { label: '已关闭', value: 5500 },
]


/**
 * 逾期总表配置
 */
const config = function () {
  return {
    columns: [
      {
        name: 'customerId',
        columnProps: {
          label: '客户ID',
          prop: 'customerId',
          width: '100',
        },
      },
      {
        name: 'customerName',
        columnProps: {
          label: '客户名称',
          prop: 'customerName',
          width: 110,
        },
      },
      {
        name: 'customerType',
        columnProps: {
          label: '客户来源',
          prop: 'customerType',
        },
        render: ({ row }) => {
          const findItem = customerTypeOptions.find((item) => item.value === row.customerType)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      // {
      //   name: 'orderState',
      //   columnProps: {
      //     label: '订单状态',
      //     prop: 'orderState'
      //   }
      // },
      {
        name: 'receivableDepositAmount',
        columnProps: {
          label: '应收总押金（当前）',
          prop: 'receivableDepositAmount',
          width: '160px',
        },
      },
      {
        name: 'depositAmount',
        columnProps: {
          label: '实收总押金（当前）',
          prop: 'depositAmount',
          width: '160px',
        },
        columnHeaderTooltip: '实收总押金（当前）=一次性已交押金之和或分期支付押金之和',
      },
      {
        name: 'arrears',
        columnProps: {
          label: '逾期总欠款（截至上月底）',
          prop: 'arrears',
          width: '210px',
        },
        columnHeaderTooltip: '逾期总欠款（截至上月底）：截止当前月的前一个月月底客户逾期欠款总金额',
      },
      {
        name: 'totalAmount',
        columnProps: {
          label: '应收总租金（当前）',
          prop: 'totalAmount',
          width: '160px',
        },
      },
      {
        name: 'receivedAmount',
        columnProps: {
          label: '实收总租金（当前）',
          prop: 'receivedAmount',
          width: '160px',
        },
      },
      {
        name: 'surplusAmount',
        columnProps: {
          label: '欠租总金额（当前）',
          prop: 'surplusAmount',
          width: '160px',
        },
        columnHeaderTooltip: '截止当前月客户所欠租金总金额',
      },
      {
        name: 'finishedState',
        columnProps: {
          label: '还款状态',
          prop: 'finishedState',
        },
        // 这里后端直接返回的文字
        tagProps: ({ row }) => { return { type: row.finishedState === '已结清' ? 'success' : 'warning', text: row.finishedState } },
        type: 'tag',
      },
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
          width: '340',
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const result = []
          if (this.judgePermission('under_lease_over_due_sum_list_detail')) {
            result.push(
              { name: 'detail', label: '查看详情', action: () => this.detailHandle(row) },
            )
          }
          return result
        },
        type: 'operate',
      },
    ],
    orderStateOptions,
    customerTypeOptions,
    summaryMap,
    repaymentStateOption,
    leaseStatusOption,
  }
}

export default config
